<template lang="pug">
.chunks(v-if="size")
  .row(v-for="c in size")
    template(v-for="r in size")
      .chunk(
        :class="chunkCss(chunkNumber(c, r))",
        :id="`c-${chunkNumber(c, r)}`"
      )
  .row.frame
    ul.plain.small.txt-center
      li Received {{ chunksDone }} of {{ cache.size }} chunks
      li.spaced(v-if="progress")
        progress-bar(:progress="progress", :width="150")
      li(v-if="progress")
        small {{ progress }}%
      li.spaced(v-if="elapsed && totalTime")
        small {{ elapsed | mToTime }} / {{ totalTime | mToTime }}
</template>
<script>
import { mapGetters } from 'vuex'
import ProgressBar from '@/components/ProgressBar.vue'
import { mToSeconds, mToTime } from '@/filters/timeFilters.js'
export default {
  name: 'file-chunks',
  props: ['chainId', 'address'],
  components: {
    ProgressBar
  },
  filters: { mToSeconds, mToTime },
  computed: {
    cache () {
      const { chainId, address, getCache } = this
      return getCache()({ chainId, address })
    },
    size () {
      const { size } = this.cache
      return size ? Math.ceil(Math.sqrt(size)) : 0
    },
    chunksDone () {
      return Object.keys(this.cache.chunks).length
    },
    progress () {
      const { chunksDone } = this
      const { size } = this.cache
      return (!size || !chunksDone) ? 0 : Math.floor(chunksDone * 100 / size)
    },
    elapsed () {
      const { chainId, address, getChunksTime } = this
      const time = getChunksTime()({ chainId, address })
      return time
    },
    totalTime () {
      const { elapsed, chunksDone, cache } = this
      if (!elapsed || !chunksDone) return 0
      const avg = elapsed / chunksDone
      return Math.ceil(cache.size * avg)
    }
  },
  methods: {
    ...mapGetters(['getCache', 'isChunkRequested', 'getChunksTime']),
    chunkNumber (c, r) {
      return r - 1 + this.size * (c - 1)
    },
    chunkCss (chunk) {
      if (chunk > this.cache.size) return 'disabled'
      const { isChunkRequested, address, chainId, cache } = this
      const isRequested = isChunkRequested()({ address, chainId, chunk })
      const done = cache.chunks[chunk]
      if (done) return 'done'
      if (isRequested) return 'requested'
    }
  }
}
</script>
<style lang="stylus">
@import '../style/variables.styl'

.chunks
  display flex
  flex-flow column wrap
  align-items center
  margin 1em

  .spaced
    margin 1em 0 0 0

.row
  display flex
  flex-flow row wrap

.chunk
  width 10px
  height 10px
  margin 1px
  background gray

  &.requested
    background info

  &.done
    background brand

  &.disabled
    background none
</style>
